import React, { createContext, useState } from 'react';
import { verifyRecaptcha } from '../utils/verifyRecaptcha';

export const ReCaptchaContext = createContext();

export const ReCaptchaProvider = ({ children }) => {
    const [captchaVerified, setCaptchaVerified] = useState(false);

    const onCaptchaVerify = async () => {
        const token = await window.grecaptcha.execute('6LdlhuAqAAAAAKu2OwDigCPRNScdFQQpA6UtXXOS', { action: 'submit' });
        const status = await verifyRecaptcha(token);
        setCaptchaVerified(status);
        return status;
    };

    return (
        <ReCaptchaContext.Provider value={{ captchaVerified, onCaptchaVerify }}>
            {children}
        </ReCaptchaContext.Provider>
    );
};
